
import { PropSync, Vue, Component, InjectReactive, Ref } from "vue-property-decorator";
import { DiagnosesType2Enum } from "@/enum/common.enum";
import { prescriptionCopy } from "@/api/prescriptionDb";

import { ElForm } from "element-ui/types/form";

const keyNameMap = {
    pulse: "智能脉诊",
    tongue: "智能舌诊",
    physique: "体质辨识",
    lung: "肺功能",
    height: "智能体脂",
    four: "四诊合参",
}

@Component({})
export default class CopyPrescriptionDialog extends Vue {
    @PropSync("visible") dialogVisible !: boolean;
    @InjectReactive() merchantId!: string|number;
    @Ref("validateForm") validateFormRef: ElForm;

    keyNameMap = keyNameMap;

    formData = {
        pulse: [],
        tongue: [],
        physique: [],
        lung: [],
        height: [],
        four: [],
    }

    loading = false;

    get saveEnable() {
        return this.formKeys?.some((key: string) => {
            return this.formData[key]?.length;
        })
    }

    get formKeys() {
        return Object.keys(this.formData);
    }

    dialogClose() {
        this.validateFormRef?.resetFields();
        this.dialogVisible = false;
    }

    save() {
        const params = {
            targetMerchantId: this.merchantId,
            sourceCategories: this.formKeys?.map((key: string) => {
                return {
                    libCode: DiagnosesType2Enum[key],
                    preCategoryIds: this.formData[key],
                }
            })?.filter(el => el.preCategoryIds?.length)
        }
        this.loading = true;
        prescriptionCopy(params).then(() => {
            this.$message.success("操作成功");
            this.dialogClose();
        }).finally(() => {
            this.loading = false;
        })
    }

}
